(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-mm-golden-story]').forEach(story => {
      if (story.dataset.ready) return;
      story.dataset.ready = 'true';
      story.querySelectorAll('[data-mm-golden-choose]').forEach(link => {
        link.addEventListener('click', event => {
          const root = story.closest('[data-mm-design-product]');
          const radio = root?.querySelector(`[data-mm-variant-choice][value="${link.dataset.mmGoldenChoose}"]`);
          if (!radio || radio.disabled) return;
          event.preventDefault();
          radio.click();
          root.querySelector('.mm-design-purchase')?.scrollIntoView({block: 'start', behavior: 'auto'});
          radio.focus({preventScroll: true});
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), {once: true});
  else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
